import { RedirectUrlResponse } from '@quadminds/client-apis/auth';
import { useQuery } from 'react-query';
import { authApi, storkAuthApi } from '../services/api';
import { isMindy, isOms, isStorkUser } from '../utils';

export const useRedirect = (trigger = false, callback: (response: RedirectUrlResponse) => void) => {
    const api = isStorkUser() && (isMindy || isOms) ? storkAuthApi : authApi;

    return useQuery(['redirect'], () => api.redirect(), {
        refetchOnWindowFocus: false,
        enabled: trigger,
        onError: () => callback,
        onSuccess: (response) => callback(response),
    });
};
